<template>
    <div class="titulos">
        <g-card class="card-titulos"
        margem="20px"
        :expansivel="true"
        :comecaFechado="false">
            <template #cabecalho>
                <div class="header-filtros">
                    <div class="titulo-filtros-cabecalho"> Títulos </div>
                    <div class="header-icons">
                        <g-button
                        class="trash-box"
                        tipo="cinza"
                        altura="35px"
                        largura="45px"
                        icone="icone_lixo.svg"
                        tamanhoIcone="15px"
                        somenteIcone
                        :sombreado="false"
                        v-tooltip="'Limpar filtro'"
                        @click="limpar"
                        />
                        <g-button
                        class="buscar-button-header-filtro"
                        largura="150px"
                        icone="icone_lupa.svg"
                        negritoTexto
                        tamanhoIcone="15px"
                        tamanhoTexto="15px"
                        altura="35px"
                        gap="10px"
                        :sombreado="false"
                        @click="buscarByFiltro()"
                        >
                            BUSCAR
                        </g-button>
                    </div>
                </div>
            </template>

            <g-form>
                <div class="titulos-conteudo espacamento-filtros">
                    <div class="data-emissao">
                        <div class="data-emissao-titulo titulo-conteudo-filtros"> Período de Emissão </div>
                        <div class="input-data">
                            <div class="data-inicio">
                                <g-date-input
                                class="data-emissao-inicio-input input-label"
                                placeholderinput="Início"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                                v-model="objFiltro.DataEmissaoInicio"
                                ></g-date-input>
                                </div>
                                <div class="data-periodo"> à </div>
                                <div class="data-termino">
                                <g-date-input
                                class="data-emissao-termino-input input-label"
                                placeholderinput="Término"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                                v-model="objFiltro.DataEmissaoTermino"
                                ></g-date-input>
                            </div>
                        </div>
                    </div>

                    <div class="data-vencimento">
                        <div class="data-vencimento-titulo titulo-conteudo-filtros"> Período de Vencimento </div>
                        <div class="input-data">
                            <div class="data-inicio">
                                <g-date-input
                                class="data-vencimento-inicio-input input-label"
                                placeholderinput="Início"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                                v-model="objFiltro.DataVencimentoInicio"
                                ></g-date-input>
                                </div>
                                <div class="data-periodo"> à </div>
                                <div class="data-termino">
                                <g-date-input
                                class="data-vencimento-termino-input input-label"
                                placeholderinput="Término"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                                v-model="objFiltro.DataVencimentoTermino"
                                ></g-date-input>
                            </div>
                        </div>
                    </div>

                    <div class="data-baixa">
                        <div class="data-baixa-titulo titulo-conteudo-filtros"> Período de Baixa </div>
                        <div class="input-data">
                            <div class="data-inicio">
                                <g-date-input
                                class="data-baixa-inicio-input input-label"
                                placeholderinput="Início"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                                v-model="objFiltro.DataBaixaInicio"
                                ></g-date-input>
                                </div>
                                <div class="data-periodo"> à </div>
                                <div class="data-termino">
                                <g-date-input
                                class="data-baixa-termino-input input-label"
                                placeholderinput="Término"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                invertido
                                :dataPassadas="true"
                                v-model="objFiltro.DataBaixaTermino"
                                ></g-date-input>
                            </div>
                        </div>
                    </div>

                    <div class="numero-notaFiscal">
                        <div class="numero-notaFiscal-titulo titulo-conteudo-filtros"> Nota Fiscal </div>
                        <PInputText
                        class="numero-notaFiscal-input input-label"
                        placeholder="Insira o número da nota fiscal"
                        v-model="objFiltro.NumeroNotaFiscal"
                        />
                    </div>

                    <div class="numero-titulo">
                        <div class="numero-titulo-titulo titulo-conteudo-filtros"> Número do Título </div>
                        <PInputText
                        class="numero-titulo-input input-label"
                        placeholder="Insira o número do título"
                        v-model="objFiltro.NumeroTitulo"
                        :useGrouping="false"
                        />
                    </div>

                    <!-- <div class="tipo">
                        <div class="tipo-titulo titulo-conteudo-filtros"> Tipo </div>
                        <PDropDown
                        class="tipo-input input-label"
                        placeholder="Selecione"
                        optionLabel="text"
                        optionValue="value"
                        v-model="objFiltro.TipoEmissao"
                        :options="TipoEmissaoArray"
                        />
                    </div>  -->

                    <div class="situacao">
                        <div class="situacao-titulo titulo-conteudo-filtros"> Situação</div>
                        <PDropDown
                        class="situacao-input input-label"
                        placeholder="Selecione"
                        optionLabel="text"
                        optionValue="value"
                        v-model="objFiltro.SituacaoDocumento"
                        :options="SituacaoArray"
                        />
                    </div>


                    <div class="tipo-documento">
                        <div class="tipo-documento-titulo titulo-conteudo-filtros"> Tipo de Documento </div>
                        <PDropDown
                        class="tipo-documento-input input-label"
                        placeholder="Selecione"
                        :filter="true"
                        optionLabel="text"
                        optionValue="value"
                        :options="TipoArray"
                        v-model="objFiltro.TipoDocumento"
                        >
                        </PDropDown>
                    </div>

                    <div class="unidade">
                        <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                        class="unidade-input input-label unidade"
                        placeholder="TODAS"
                        :filter="true"
                        optionLabel="nome"
                        optionValue="id"
                        v-model="objFiltro.EmpresaId"
                        :options="EmpresaArray"
                        >
                        </PDropDown>
                    </div>

                    <div class="cliente">
                        <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
                        <!-- <PDropDown
                        class="cliente-input input-label"
                        placeholder="Selecione o cliente"
                        :filter="true"
                        :options="ClientesArray"
                        :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                        @filter="buscarClientes($event.value)"
                        optionLabel="nomeFantasia"
                        optionValue="id"
                        v-model="objFiltro.ClienteId"
                        >
                            <template #option="slotProps">
                                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                            </template>
                        </PDropDown> -->
                        <cliente-dropdown
                            class="cliente-input input-label"
                            v-model="objFiltro.ClienteId"
                            @change="ativaClienteAgrupador"
                            :empresaId="objFiltro.EmpresaId"
                            :representanteId="this.$store.state.representanteSelecionadoId"
                        />
                    </div>

                    <div class="parametros">
                        <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>
                        <div class="parametros-checkboxes">
                            <div class="consultar-dados checkbox">
                                <PCheckBox :disabled="ClienteAgrupadorAtiva" :binary="true" id="consultar-dados"  class="checkbox-consultas" v-model="objFiltro.DadosClienteAgrupador"></PCheckBox>
                                <label class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                            </div>
                        </div>
                    </div>

                   
                </div>
            </g-form>

            <div class="buscar-button-filtro">
                <g-button
                class="buscar-button"
                largura="300px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="buscarByFiltro()"
                >
                BUSCAR
                </g-button>
            </div>
        </g-card>

        <g-card paddingDefault="0" margem="20px" :expansivel="false" :temCabecalho="false" class="card-resultado">
            <div v-if="mensagemvazio" class="">
                <img
                class="icone-global-imagemfundo"
                src="@/assets/imgs/Ilustracao_erro.svg"
                />
                <div class="texto-padrao-imagemfundo">
                    Verifique os filtros e clique em buscar para exibir os resultados
                </div>
            </div>

            <div class="grid-container" v-else-if="!mensagemvazio"> 
               
                <div class="grid-item" v-for="repre,index in arrayRepresentantes"
                    :key="index"
                >
                <!-- {{ `Títulos : ${repre.nomeRepresentante} | Total do Representante : ${retornaTotalDoValorDoRepresentanteFormatado(repre.totalDoValorDoRepresentante)}` }} -->
                <g-data-table
                    :Titulo="`Títulos : ${repre.nomeRepresentante} | Total do Representante : ${retornaTotalDoValorDoRepresentanteFormatado(repre.totalDoValorDoRepresentante)}`"
                    altura="auto"
                    :valores="repre.titulos"
                    :colunas="Colunas"
                    :GetStatusColors="'colorButtonStatus'"
                    :colunaColorida="'diasAtraso'"
                    :Filtros="Filtro"
                    :FiltrosEspecificos="true"
                    :NumeroLinhas="100"
                    :Paginacao="true"
                    :Pedidos="true"
                    TextPedidos="Pedidos vinculados ao título"
                    v-on:onPedidos="GetPedidoByDocumentoId"
                    v-on:duploClickLinha="redirecionaTelaDetalhes"
                    :campoAgrupador="'labelAgrupador'"
                    :campoExibicaoGrupo="'labelAgrupador'"
                    :telaTitulos = true
                >
                    <template #groupfooter="slotProps">  
                        <g-data-table
                            :valores="[{}]"
                            :ehSemDados="false"
                            :ehReordenavel="false"
                            :Paginacao = false
                            :colunas="[
                                    {header: 'Total Cliente: '},
                                    {header: slotProps.soma.somaFinalValorBruto},
                                    {header: ''},
                                    {header: ''},
                                    {header: ''},
                                    {header: ''},
                                    {header: ''},
                                    {header: ''},
                            ]"
                            :esconderHeader="true"
                            :esconderColunaFrozen="true"
                        >
                        </g-data-table>
                    </template>
                </g-data-table>

                
                </div>
                
                
                <p class="valor-container">
                    {{ `Total Geral: ${retornaTotalDoValorDoRepresentanteFormatado(totalDeTodosOsRepresentates)}` }}
                </p>
            </div>
        </g-card>
    </div>
</template>

<script>
import Titulos from './Titulos.js'

export default Titulos
</script>

<style scoped>
.valor-container{
    width: 100%;
    text-align: center;
    vertical-align: middle;
    padding: 1rem;
    margin: 0;
    font-size: 1.2rem;
    font-weight: 500;
    font-family: "MontSerrat";
    background-color: #f8f9fa;


}
.grid-container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap:1rem;
    /* background-color: #4f2c19cc; */
}

.grid-item{
    padding: 0.6rem 0rem;
    border: 2px solid #dad8d8;
}
.card-titulos-header {
    display: flex;
    justify-content: space-between;
   
}

.header-icons-consultas {
    display: flex;
    justify-content: flex-end;
}

.trash-box-consultas {
    margin-left: 5px;
}

.card-titulos-titulo {
    color: #4f2c19;
    text-align: left;
    font-weight: bold;
    align-self: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.titulo {
    color: #747474;
    text-align: left;
    font-family: Montserrat;
    font-weight: bold;
    padding: 5px 0;
}

.checkbox {
    display: flex;
    padding-top: 3px;
    padding-bottom: 3px;
}

.label-checkbox {
    color: #8A8A8A;
    text-align: left;
    font-size: 15px;
    font-family: 'MontSerrat';
    margin-left: 5px;
}

.input-label {
    margin-bottom: 15px;
}

.card-resultado-text-small {
    color: #4F4C4D;
    font-family: 'MontSerrat';
}

.card-resultado-content {
    display: flex;
    flex-direction: column;
}

.imagem-nenhuma-info {
    margin: 60px auto 20px auto;
    max-height: 500px;
}

.buscar-button-consulta {
    display: flex;
    align-content: center;
    justify-content: center;
}

.data-emissao-periodo, .data-vencimento-periodo, .data-baixa-periodo {
    color: #747474;
    font-family: Montserrat;
}

.codigo-nome-produto {
    width: 100%;
}


@media (min-width: 310px) {
.unidade { order: 1 }
.buscar-button-header {
    display: none;
}

.card-titulos-titulo {
    font-size: 16px;
}

/* .titulos-conteudo {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
} */

.titulos-conteudo {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(7, auto);
    grid-column-gap: 20px;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 2 / 1 / 3 / 2; }
.numero-titulo { grid-area: 3 / 1 / 4 / 2; }
.numero-notaFiscal { grid-area: 4 / 1 / 5 / 2; }
.tipo-documento { grid-area: 5 / 1 / 6 / 2;}
.tipo { grid-area: 6 / 1 / 7 / 2; }
.situacao { grid-area: 7 / 1 / 8 / 2; }
.data-emissao-input { grid-area: 8 / 1 / 9 / 2; }
.data-vencimento-input { grid-area: 9 / 1 / 10 / 2; }
.data-baixa-input { grid-area: 10 / 1 / 11 / 2; }
.parametros { grid-area: 11 / 1 / 12 / 2; }


.titulo {
    font-size: 14px;
}

.codigo-nome-produto {
    display: grid;
    grid-template-columns: 30% auto;
    grid-template-rows: auto;
    grid-column-gap: 20px;
    align-items: flex-end;
}

.data-emissao-input, .data-vencimento-input, .data-baixa-input {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: 100%;
    grid-column-gap: 4%;
}
.data-emissao-inicio, .data-vencimento-inicio, .data-baixa-inicio { grid-area: 1 / 1 / 2 / 2; }
.data-emissao-periodo, .data-vencimento-periodo, .data-baixa-periodo { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.data-emissao-termino, .data-vencimento-termino, .data-baixa-termino { grid-area: 1 / 3 / 2 / 4; }

.input-label {
    width: 100%;
}

.buscar-button-filtro {
  display: flex;
  justify-content: center;
  align-items: self-end;
}

.imagem-nenhuma-info {
    height: 15vh;
}
}

@media (min-width: 368px) {
.card-titulos-titulo {
    font-size: 18px;
}
}

@media (min-width: 600px) {
.buscar-button-header {
    display: block;
    margin-left: 15px;
}

.card-titulos-titulo {
    font-size: 20px;
}

/* .titulos-conteudo {
    display: grid;
    grid-template-columns: 47% 49.5%;
    grid-template-rows: repeat(7, auto);
    grid-column-gap: 20px;
}

.data-emissao-input { grid-area: 1 / 1 / 2 / 2; }
.data-vencimento-input { grid-area: 1 / 2 / 2 / 3; }
.data-baixa-input { grid-area: 2 / 1 / 3 / 2; }
.numero-notaFiscal { grid-area: 2 / 2 / 3 / 3; }
.numero-titulo { grid-area: 3 / 1 / 4 / 2; }
.tipo { grid-area: 3 / 2 / 4 / 3; }
.situacao { grid-area: 4 / 1 / 5 / 2; }
.tipo-documento { grid-area: 4 / 2 / 5 / 3; }
.unidade { grid-area: 5 / 1 / 6 / 3; }
.cliente { grid-area: 6 / 1 / 7 / 3; }
.parametros { grid-area: 7 / 1 / 8 / 3; } */


.buscar-button-filtro {
  display: none;
}

.imagem-nenhuma-info {
    height: 25vh;
}
}

@media (min-width: 801px) {

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-titulo { grid-area: 2 / 1 / 3 / 2; }
.numero-notaFiscal { grid-area: 2 / 2 / 3 / 3; }
.tipo-documento { grid-area: 3 / 1 / 4 / 2;}
.tipo { grid-area: 3 / 2 / 4 / 3; }
.situacao { grid-area: 4 / 1 / 5 / 2; }
.data-emissao-input { grid-area: 4 / 2 / 5 / 3;  }
.data-vencimento-input { grid-area: 5 / 1 / 6 / 2; }
.data-baixa-input { grid-area: 5 / 2 / 6 / 3; }
.parametros { grid-area: 6 / 1 / 7 / 2; }

.parametros-checkboxes {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    column-gap: 20px;
}
}

@media (min-width: 1025px) {
.card-titulos-titulo {
    font-size: 22px;
}

.titulos-conteudo {
    grid-template-columns: 49% 49%;
    grid-template-rows: repeat(4, auto);
    margin: 20px 20px 0 20px;
}

.imagem-nenhuma-info {
    height: 35vh;
}
}

@media (min-width: 1281px) {
.titulos-conteudo {
    grid-template-columns: repeat(4, minmax(6em, 1fr));
    grid-template-rows: repeat(3, auto);
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-titulo { grid-area: 1 / 3 / 2 / 4; }
.numero-notaFiscal { grid-area: 1 / 4 / 2 / 5; }
.tipo-documento { grid-area: 2 / 1 / 3 / 2; }
.tipo { grid-area: 2 / 2 / 3 / 3;}
.situacao { grid-area: 2 / 3 / 3 / 4; }
.data-baixa-input {grid-area: 2 / 4 / 3 / 5; }
.data-emissao-input { grid-area: 3 / 1 / 4 / 2; }
.data-vencimento-input { grid-area: 3 / 2 / 4 / 3; }
.parametros { grid-area: 3 / 3 / 4 / 5; }
}

@media (min-width: 1500px) {
}
</style>